
import { bodyRequest, getRequest } from '@react/helpers/fetch'

export class ApiError extends Error {
  constructor(messages) {
    super(messages.join(', '))
    this.messages = messages
  }
}

// The controller answers a refused save with { errors: [...] }
const checked = (promise) => promise.then((payload) => {
  if (payload && payload.errors) { throw new ApiError([].concat(payload.errors)) }
  return payload
})

const request = (method, url, body) => checked(method === 'GET' ? getRequest(url) : bodyRequest({ method, url, body }))

// The controller reads the options as one "a;b;c" string and the table as JSON
export const fieldParams = (field) => ({
  field_type:       field.field_type,
  data_type:        field.data_type,
  name:             field.name,
  order:            field.order,
  section_id:       field.section_id,
  is_mandatory:     !!field.is_mandatory,
  can_be_filled:    !!field.can_be_filled,
  can_be_copied:    !!field.can_be_copied,
  options:          (field.options || []).join(';'),
  options_prefill:  (field.options_prefill || []).join(';'),
  has_extra_option: !!field.has_extra_option,
  multi_option:     !!field.multi_option,
  hide_unselected:  !!field.hide_unselected,
  prefill_with:     field.prefill_with,
  text_align:       field.text_align,
  table_columns:    field.table_columns ? JSON.stringify(field.table_columns) : undefined,
  visible_when:     JSON.stringify(field.visible_when || {})
})

export const sectionParams = (section) => ({
  name:         section.name,
  order:        section.order,
  duplicable:   !!section.duplicable,
  text_align:   section.text_align,
  visible_when: JSON.stringify(section.visible_when || {})
})

export const positionParams = (position) => ({
  field_id:       position.field_id,
  option:         position.option === undefined ? null : position.option,
  page_number:    position.page_number,
  x1:             Math.round(position.x1 * 10) / 10,
  y1:             Math.round(position.y1 * 10) / 10,
  x2:             Math.round(position.x2 * 10) / 10,
  y2:             Math.round(position.y2 * 10) / 10,
  font:           position.font,
  font_size:      position.font_size,
  font_size_auto: position.font_size_auto,
  bold:           position.bold,
  italic:         position.italic,
  fill_color:     position.fill_color
})

export const createApi = (blueprintId) => {
  const base = `/blueprints/${blueprintId}`

  return {
    load:           ()               => request('GET',    `${base}/edit`),
    updateForm:     (attributes)     => request('PATCH',  base, { blueprint: attributes }),
    createField:    (field)          => request('POST',   `${base}/create_field`, { field: { ...fieldParams(field), blueprint_id: blueprintId } }),
    updateField:    (field)          => request('PATCH',  `${base}/update_field?field_id=${field.id}`, { field: fieldParams(field) }),
    destroyField:   (id)             => request('DELETE', `${base}/destroy_field?id=${id}`),
    createSection:  (section)        => request('POST',   `${base}/create_section`, { field: sectionParams(section) }),
    updateSection:  (section)        => request('PATCH',  `${base}/update_section?id=${section.id}`, { field: sectionParams(section) }),
    duplicateSection: (id)           => request('PATCH',  `${base}/duplicate_section?id=${id}`),
    destroySection: (id)             => request('DELETE', `${base}/destroy_section?id=${id}`),
    reorder:        (fields)         => request('PATCH',  `${base}/reorder_fields`, { fields }),
    createPosition: (position)       => request('POST',   `${base}/field_positions`, { field_position: positionParams(position) }),
    updatePosition: (position)       => request('PUT',    `${base}/field_positions/${position.id}`, { field_position: positionParams(position) }),
    destroyPosition: (id)            => request('DELETE', `${base}/field_positions/${id}`)
  }
}
